import wrapWithProvider from "./wrap-with-provider";

import "./src/styles/global.css";

export const wrapRootElement = wrapWithProvider;
